/**
 * Derives the route prefix ('/store' or '/superadmin') from the current Router URL.
 * Used by huddle flow components to navigate context-aware paths.
 */
export function getRoutePrefix(currentUrl: string): string {
  if (currentUrl.startsWith('/store')) {
    return '/store';
  }
  return '/superadmin';
}
